import type { KlarnaConfig } from '#types/config/components/klarna'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    disclaimerText: '<md:text-sm',
    introText: 'mb-6 text-base',
    logo: 'ml-1'
  },
  installments: {
    'en-us': 4
  },
  showLogoHeader: true,
  showDialogTitle: true,
} satisfies RecursivePartial<KlarnaConfig>
